import { Button, Dialog } from '@optimus-web/core';
import { LocalizedText, showSuccessAlert } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { useRepositoryMutation } from '@mews-commander/data-access';

interface Props {
    userIds: string[];
    onSuccess?: () => void;
    onClose: () => void;
    active: boolean;
}

export const DeleteUsersDialog = ({ userIds, onSuccess, onClose, active }: Props) => {
    const { mutate, isPending } = useRepositoryMutation('userProfiles', 'delete', {
        onSuccess: (_, { userIds: deletedUserIds }) => {
            onSuccess?.();
            onClose();

            showSuccessAlert({
                description: (
                    <LocalizedText
                        textKey={TextKey.UserProfileDeleteSuccessMessagePlural}
                        substitutes={{ count: deletedUserIds.length }}
                    />
                ),
            });
        },
        invalidateQueries: { userProfiles: ['getAll'] },
    });

    return (
        <Dialog
            title={<LocalizedText textKey={TextKey.RemoveUsersTitle} />}
            loading={isPending}
            onClose={onClose}
            footer={{
                secondary: (
                    <Button onClick={onClose} variant="tertiary" size="medium" data-test-id="cancel" type="submit">
                        <LocalizedText textKey={TextKey.Cancel} />
                    </Button>
                ),
                primary: (
                    <Button
                        onClick={() => mutate({ userIds })}
                        variant="destructive"
                        size="medium"
                        data-test-id="remove"
                        type="submit"
                    >
                        <LocalizedText textKey={TextKey.Remove} />
                    </Button>
                ),
            }}
            active={active}
        >
            <LocalizedText textKey={TextKey.RemoveUsersContent} />
        </Dialog>
    );
};
